import React from 'react';

const Input = ({name,placeholder,id, errors, value, handleChange}) => {

    return (
        <div>
            <label className="mb-0 mt-2">{placeholder}</label>
            <div className="input-group wow fadeInUp mt-0" data-wow-delay="1.8s">
                <input
                    name={name}
                    type="text"
                    id={id}
                    className="form-control"
                    placeholder={placeholder}
                    onChange={handleChange}
                    value={value}
                    autoComplete = "off"
                />
                <div
                    id={`${id}-error`}
                    className="invalid-feedback animated fadeInUp p-0"
                    style={{ display: "block" }}
                >
                    {errors && errors}
                </div>
            </div>
        </div>

    )

}

export default Input



